<template>
  <div class="tables-basic">
      <div v-if="loading" class="page-loading-container">
          <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
      <div class="float-right" id="top">
          <b-pagination-nav v-model="currentPage" :link-gen="linkGen()" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
      </div>

    <h2 class="page-title">Spelling Issues</h2>
      <b-alert v-if="!scanStatus.completed" show variant="primary"><b-spinner label="Loading..." style="width:16px;height:16px"></b-spinner> Check in progress.<br>
          Results will show up here automatically</b-alert>
      <b-alert v-if="scanStatus.completed && spellingErrors.length === 0" show variant="success"><span class="glyphicon glyphicon-thumbs-up" style="font-size:16px"></span> No Issues found.</b-alert>

    <b-row v-if="spellingErrors.length > 0">
      <b-col>
        <Widget
        >
          <b-row v-for="(spellingError, index) in spellingErrors">
            <b-col lg="12" sm="12" xs="12">
                <div class="table-responsive">
                  <table class="table table-sm table-outlined" >
                    <thead v-if="index === 0">
                    <tr >
                      <th ><table width="100%" class="table-borderless">
                          <tr><td width="40%" >
                          Word</td>
                              <td align="center" width="50%">Suggestion</td>
                              <td align="center">Approve</td></tr></table></th>
                      <th ><table width="100%" class="table-borderless"><tr>
                          <td align="center">
                       Preview</td>
                      </tr></table></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="spelling">

                      <td width="75%">   <table width="100%" class="table-borderless"><tr>
                          <td width="60%" style="font-size:140%">
                          <b class="">{{spellingError.word}}</b></td>
                          <td width="35%" style="vertical-align:middle">{{spellingError.suggestion}} </td
                      >
                      <td ><b-button v-b-tooltip.hover  :title="`Add ${spellingError.word} to the dictionary`" variant="outline-secondary" @click="approveWord(spellingError)"><i class="fa fa-thumbs-up"></i></b-button></td>
                      </tr></table>


                      <div style="margin-left:12px">
                          <table class="table table-sm " >

                              <tr v-for="(page, i) in spellingError.pages" @mouseover="mouseOver(spellingError, i)" v-bind:key="page.word">
                                  <td :to="{ name: 'ViewPage', params: {type: 'spelling'}, query: {page: page.url, site:activeSite.id, focus: spellingError.word} }" :class="{'spelling-page-selected': spellingError.selectedPageIndex === i}">
                                      <router-link :to="{ name: 'ViewPage', params: {type: 'spelling'}, query: {page: page.url, site:activeSite.id} }">
                                          <b-badge style="width:20px;padding: 0.4em 0.4em;" pill variant="warning" v-b-tooltip.hover v-b-tooltip.noninteractive :title="`${page.occurrences} occurrences on page`"> <b-spinner style="width:1em;height:1em" v-if="page.pending"  small label="Small Spinner"></b-spinner><span v-if="!page.pending">{{page.occurrences}}</span></b-badge> </router-link>  &nbsp;
                                      <a :href="page.url" target="_blank" v-b-tooltip.hover v-b-tooltip.noninteractive title="External Link">{{page.url}}</a>
                                      <div style="float:right;margin-right:10px;font-size:110%">
                                      <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }"  v-b-tooltip.hover v-b-tooltip.noninteractive title="Page Details"><i class="fa fa-eye"></i> Page Details</router-link> &nbsp;
                                      <router-link  v-b-tooltip.hover v-b-tooltip.noninteractive title='Locate on page' :to="{ name: 'ViewPage', params: {type: 'spelling'}, query: {page: page.url, site:activeSite.id, focus: spellingError.word} }" ><i class="fa fa-search"></i> Locate</router-link>
                                      </div>

                                  </td>
                              </tr>
                          </table>
                      </div>
                      </td>

                      <td width="25%">
                          <div style="font-weight:bolder;font-size:120%">
                              <router-link title='Locate on page' :to="{ name: 'ViewPage', params: {type: 'spelling'}, query: {page: spellingError.pages[spellingError.selectedPageIndex].url, site:activeSite.id, focus: spellingError.word} }">
                                  <div v-if="spellingError.pages[spellingError.selectedPageIndex].error" class="image-loading-container" style="width:200px;height:100px;font-size:8pt">
                                      <div><p></p>Could Not Generate Preview.</div>
                                  </div>
                                  <div v-else-if="!spellingError.pages[spellingError.selectedPageIndex].pending">
                                      <vue-load-image v-if="spellingError.pages[spellingError.selectedPageIndex].preview.visible">
                                          <img slot="image" width=200  :src="`${spellingError.pages[spellingError.selectedPageIndex].preview.url}`" class="spelling-preview-image">
                                          <div slot="preloader" class="image-loading-container" style="width:200px;height:100px;box-shadow: 0 0 40px #f0f3ff;"><div><b-spinner label="Loading..." ></b-spinner><br>Loading.. </div></div>
                                          <div slot="error" class="screenshot-error" style="width:200px;height:100px;color:orange">
                                              <p><i class="fa fa-warning"></i></p>
                                             <p>
                                                  Preview not available
                                              </p>

                                          </div>
                                      </vue-load-image>
                                      <div v-else class="image-loading-container" style="height:100px"><div style="border:1px dotted orange;border-radius:10px;padding:5px;font-size:9pt">Not visible on page load</div></div>
                                  </div>
                                  <div v-else class="image-loading-container" style="width:200px;height:100px;font-size:8pt"><div><b-spinner label="Loading..." ></b-spinner><p></p>Generating Preview.. </div></div>
                              </router-link>
                          </div>   </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
            </b-col>
          </b-row>
        </Widget>
          <div class="float-right">
              <b-pagination-nav v-model="currentPage" :link-gen="linkGen('#top')" use-router :number-of-pages="numberOfPages" base-url="#" first-number last-number  align="right"></b-pagination-nav>
          </div>
      </b-col>
    </b-row>
      </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import gql from "graphql-tag";
import { mapState } from 'vuex';
import axios from "axios";
import VueLoadImage from 'vue-load-image'
export default {
  name: 'Tables',
  components: { Widget, 'vue-load-image': VueLoadImage },
  apollo: {
    $subscribe: {
      spelling_error_count:{
        query(){
          return gql`subscription {
                  websites_spellingerror_aggregate(where: {active: {_eq: true}, websites_spellingerror_pages: {websites_crawledpage: {is_latest: {_eq: true}, website_id: {_eq: 885}},  }}){
                    aggregate{
                      count
                    }
                  }
}`
        },
        skip () {
          return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
        },
        result(data){
          let pageCount = data.data.websites_spellingerror_aggregate.aggregate.count;
          this.numberOfPages = Math.ceil(pageCount/this.pageSize);
          this.numberOfPages = Math.max(this.numberOfPages, 1);
        }
      },
      websites_website: {
        query() {
          return gql`subscription {
                  websites_spellingerror(limit: ${this.pageSize}, offset: ${(this.currentPage-1) * this.pageSize || 0}, where: {active: {_eq: true}, websites_spellingerror_pages: {websites_crawledpage: {is_latest: {_eq: true}, website_id: {_eq: ${this.activeSite.id}}},  }}){
                    id
                    word
                    suggestion
                    websites_spellingerror_pages(where: {websites_crawledpage: {is_latest: {_eq: true}, ready: {_eq: true}}}){
                      websites_crawledpage{
                        id
                        spellcheck_state
                        spelling_marks
                        url
                        path
                      }
                    }
                  }

          }`
        },
        skip () {
          return !this.activeSite.id || (this.dataLoaded && this.scanStatus.completed);
        },
        result (data) {
          this.spellingErrors = [];
          let marksCompleted = true;

          for (let entry of data.data.websites_spellingerror){
            let pages = [];
            for (let page of entry.websites_spellingerror_pages){
              let preview_img = {visible: false};
              let occurrences = 0;
              if (!page.websites_crawledpage.spelling_marks) {
                page.websites_crawledpage.spelling_marks = {};
              }
              let error = false;
              let pending = Object.keys(page.websites_crawledpage.spelling_marks).length === 0;
              if (pending){
                marksCompleted = true;
              }

              if (page.websites_crawledpage.spelling_marks.error){
                error = true;
              }
              else {
                if (!page.websites_crawledpage.spelling_marks[entry.word]) {
                  page.websites_crawledpage.spelling_marks[entry.word] = []
                }
                occurrences = page.websites_crawledpage.spelling_marks[entry.word].length || 0;

                for (let spelling_mark of page.websites_crawledpage.spelling_marks[entry.word]) {
                  if (spelling_mark.error) {
                    error = true;
                    break
                  }
                  if (spelling_mark.visible) {
                    preview_img = {visible: true, url: spelling_mark.screenshot.url};
                  }
                }
              }

              pages.push({
                url: page.websites_crawledpage.url,
                path: page.websites_crawledpage.path,
                spelling_marks: page.websites_crawledpage.spelling_marks || [],
                occurrences: occurrences,
                preview: preview_img,
                pending: pending,
                error: error,
              })
            }
            this.spellingErrors.push({
              word: entry.word,
              suggestion: entry.suggestion,
              pages: pages,
              selectedPageIndex: 0,
            });
          }
         this.loading = false;
         this.dataLoaded = marksCompleted;
        },

      },

    }
  },
  data() {
    return {
      pages: [],
      spellcheckCompleted: false,
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      spellingErrors: [],
      currentPage: 2,
      numberOfPages: 1,
      loading: true,
      dataLoaded: false,
      pageSize: 10,
      row_selected: false,
    };
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus"}),
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Spelling Issues - PageWatch.dev',
    // all titles will be injected into this template
  },
  methods: {
    approveWord(spellingError){
      axios
        .put(`websites/${this.activeSite.id}/dictionary/${spellingError.word}`)
        .then(
          response => {
            this.$toast.show('added to the dictionary', spellingError.word, this.toastOptions);
            this.$root.$emit('global_reload');
            return true;
          },
          error => {
            this.$toast.show(error.response.data.message, 'Unauthorized', this.toastOptions);
            return false;
          }
        );
      spellingError.pending = true;
    },
    linkGen(hash) {
      if (!hash){
        hash = '';
      }
      return (pageNum) =>{
        return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
      };
    },
    mouseOver(spellingError, index){
      spellingError.selectedPageIndex = index;
    },
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  created() {
    this.$watch("$route",() => {
      this.currentPage = this.$route.query.page || 1;
      this.dataLoaded = false;
      }, {
      immediate: true
    });
    this.$root.$on('global_reload', () => {
      this.dataLoaded = false;
    });
  }
};
</script>

<style src="./Spelling.scss" lang="scss" scoped />
<style lang="scss">
    .spelling-preview-image {
        border-radius: 50%;
        width: 200px;
        box-shadow: #bdc4e0 0px 0px 20px;
    }
  tr.spelling{
    &.selected {
      background-color: #ffdf594d;
    }
  }
  td.spelling-page-selected {
      background-color:#fafbff;
  }
  table{
    line-height: 1.2;
  }
</style>
